import * as moment from 'moment';
import { TakeLeaveType } from '../enums';

export class TakeLeaveResult {
    public id: number = 0;
    public employeeId: number = 0;
    public employeeFullName: string = '';
    public fromDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public toDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public creationDateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public takeLeaveType: TakeLeaveType = TakeLeaveType.BereavementLeave;
    public approverId?: number | null = null;
    public approverFullName: string = '';
    public isAccepted: boolean = false;
    public description: string = '';
    public isDeleted: boolean = false;
}
